// This validator takes a forbidden value and the name of the control which should not contain the forbidden value

import { AbstractControl, ValidatorFn } from "@angular/forms"

export function ForbiddenValueValidator(allowedValues: string[], forbiddenValues: string[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let controlValue = (control.value as string).trim().toUpperCase();

    for (let index = 0; index < allowedValues.length; index++) {
      let allowedValue = allowedValues[index].toUpperCase();
      if (allowedValue.endsWith("*")) {
        let prefix = allowedValue.substr(0, allowedValue.length - 1);
        if (controlValue.startsWith(prefix))
          return null;
      } else {
        if (controlValue === allowedValue)
          return null;
      }
    }
    for (let index = 0; index < forbiddenValues.length; index++) {
      let forbiddenValue = forbiddenValues[index].toUpperCase();
      if (forbiddenValue.endsWith("*")) {
        let prefix = forbiddenValue.substr(0, forbiddenValue.length - 1);
        if (controlValue.startsWith(prefix))
          return { "forbiddenValue": true };
      } else {
        if (controlValue === forbiddenValue)
          return { "forbiddenValue": true };
      }
    }

    return null;
  }
}
